/*
 * Copyright (c) 2020 SQUAREPING INC.
 *
 * SQUAREPING CONFIDENTIAL
 * [2019 and Beyond] SQUAREPING INC. All Rights Reserved.
 *
 * NOTICE: The source code contained herein is, and remains the property of SQUAREPING INC.
 * and its suppliers, if any. The intellectual and technical concepts contained herein are
 * proprietary to SQUAREPING INC. and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material is strictly forbidden
 * anywhere in the world unless prior written permission is obtained from SQUAREPING INC.
 */

import { useRef, useEffect } from 'react';
import Emitter from '../modules/Emitter.module';
import * as mitt from 'mitt';

// eventName and callBack must not change!!!!!
export default function useEvent(eventName: string, callBack: mitt.Handler<any>, deps: any[] = []) {
  const callBackRef = useRef<mitt.Handler<any>>();
  useEffect(() => {
    callBackRef.current = callBack;
    Emitter.on(eventName, callBackRef.current);
    return () => {
      if (callBackRef.current) Emitter.off(eventName, callBackRef.current);
    };
  }, deps);
}
